var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 4.5C5.47018 4.5 5.75 4.77982 5.75 5.125V18.875C5.75 19.2202 5.47018 19.5 5.125 19.5C4.77982 19.5 4.5 19.2202 4.5 18.875V5.125C4.5 4.77982 4.77982 4.5 5.125 4.5Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7C7 6.30964 7.55964 5.75 8.25 5.75H15.75C16.4404 5.75 17 6.30964 17 7V10.125C17 10.8154 16.4404 11.375 15.75 11.375H8.25C7.55964 11.375 7 10.8154 7 10.125V7ZM15.75 7H8.25V10.125H15.75V7Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.875C7 13.1846 7.55964 12.625 8.25 12.625H18.875C19.5654 12.625 20.125 13.1846 20.125 13.875V17C20.125 17.6904 19.5654 18.25 18.875 18.25H8.25C7.55964 18.25 7 17.6904 7 17V13.875ZM18.875 13.875H8.25V17H18.875V13.875Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.10f28e51fa5d35ff1528c33add1c16fc.svg";
export { ForwardRef as ReactComponent };